import React, {useEffect, useState} from "react";
import {useCountertops} from "../../contexts/countertopsContext";
import {CheckBox} from "devextreme-react/check-box";
import {NumberBox} from "devextreme-react/number-box";
import {Option} from "../../types/Option";
import {SelectedOption} from "../../types/SelectedOption";
import Validator from "devextreme-react/validator";
import {RequiredRule} from "devextreme-react/form";

export function OptionControl({prodQteGrpID, option, selectedOption, singleQty}: {
    prodQteGrpID: number,
    option: Option,
    selectedOption: SelectedOption | undefined,
    singleQty: number | undefined
}) {
    const context = useCountertops();
    const [checked, setChecked] = useState<boolean>(false);

    useEffect(() => {
        if (selectedOption === undefined) {
            setChecked(false);
        } else {
            setChecked(true);
        }
    }, [selectedOption])

    useEffect(() => {
        if (option.isOneQty && singleQty !== undefined) {
            if (singleQty !== option.productID) {
                context.removeOption(prodQteGrpID, option.productID);
            }
        }
    }, [singleQty])

    return (<tr key={option.productID}>
            <td style={{width: '30px', textAlign: "center"}}>
                <CheckBox
                    value={checked}
                    onValueChanged={(e) => {
                        if (e.event) {
                            if (e.value) {
                                let qty: number | undefined = undefined;
                                if (option.isOneQty) {
                                    qty = 1;
                                    context.updateOneQty(prodQteGrpID, option.productID);
                                }
                                context.updateOption(prodQteGrpID, option.productID, qty);
                            } else {
                                context.removeOption(prodQteGrpID, option.productID);
                            }
                        }
                    }}
                />
            </td>
            <td>
                {option.sku}&nbsp;
            </td>
            <td>
                {option.name}
            </td>
            <td>
                <img src={option.imageUrl} style={{maxWidth: '30px'}}/>
            </td>
            <td style={{width: '62px'}}>
                <NumberBox
                    min={1}
                    style={{width: '60px'}}
                    showSpinButtons={true}
                    value={selectedOption?.qty}
                    disabled={!checked}
                    readOnly={option.isOneQty}
                    valueChangeEvent='blur'
                    format={'fixedPoint'}
                    onValueChanged={(e) => {
                        if (e.event) {
                            context.updateOption(prodQteGrpID, option.productID, e.value ?? undefined)
                        }
                    }}
                >
                    <Validator>
                        <RequiredRule message={"Quantity must be set and greater than 0"}></RequiredRule>
                    </Validator>
                </NumberBox>
            </td>
            <td style={{width: '42px'}}>
                {option.uom}
            </td>
        </tr>
    )
}
